import React, { useEffect, useMemo, useState } from 'react';
import { IItemForGetShortInfo } from 'types';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';
import SearchField from 'components/SearchField/SearchField';
import FormSelect from 'components/Select/FormSelect';
import style from './MultipleSelect.module.scss';

interface IProps {
	data: IItemForGetShortInfo[];
	isApplyToOne: boolean;
	setAdditionalRestaurants: (value: string[]) => void;
	selectedAdditionalRestaurants: string[];
}

export const MultipleSelect: React.FC<IProps> = React.memo(
	({ data, isApplyToOne, setAdditionalRestaurants, selectedAdditionalRestaurants }) => {
		const [searchString, setSearchString] = useState<string>('');
		const [isSelectedAllRestaurants, setIsSelectedAllRestaurants] = useState<boolean>(false);

		const filteredRestaurants = useMemo(() => {
			return searchString
				? data.filter((el) => el.name.toLowerCase().includes(searchString.toLowerCase()))
				: data;
		}, [searchString, data]);

		const handleSelectAllRestaurants = () => {
			if (isSelectedAllRestaurants) {
				setAdditionalRestaurants([]);
			} else {
				const IDsOfAllRestaurants = data.map((el) => el.id);
				setAdditionalRestaurants(IDsOfAllRestaurants);
			}
		};

		useEffect(() => {
			setSearchString('');
		}, [isApplyToOne]);

		useEffect(() => {
			if (selectedAdditionalRestaurants.length === 0) {
				setIsSelectedAllRestaurants(false);
			} else if (selectedAdditionalRestaurants.length === data.length) {
				setIsSelectedAllRestaurants(true);
			} else if (selectedAdditionalRestaurants.length !== data.length) {
				setIsSelectedAllRestaurants(false);
			}
		}, [selectedAdditionalRestaurants.length, data.length]);

		const renderSelectMenu = (menu: React.ReactElement) => {
			return (
				<>
					<div className={style.selectMenuHeader}>
						<Checkbox
							className={style.checkBox}
							checked={isSelectedAllRestaurants}
							disabled={!data.length}
							onChange={handleSelectAllRestaurants}>
							<Text
								translationNameSpace="form"
								translationKey="selectAnyItemPlaceholder"
								asFragment={true}
							/>
						</Checkbox>
						<SearchField
							onChangeSelectSearchString={setSearchString}
							searchString={searchString}
							className={style.searchField}
						/>
					</div>
					{menu}
				</>
			);
		};

		return (
			<FormSelect
				testId="MultipleSelect"
				name="selectedAdditionalRestaurants"
				label="restaurantsLabel"
				options={filteredRestaurants}
				disabled={isApplyToOne}
				onChange={setAdditionalRestaurants}
				counterValue={selectedAdditionalRestaurants.length}
				dropdownRender={renderSelectMenu}
				mode="multiple"
			/>
		);
	},
);
